import { useState } from "react";
import { useLocation } from "react-router-dom";

interface Props {
  className?: string;
  url?: string;
  enableHover?: boolean;
}

export const HeaderFyLogo = ({
  className = "",
  url = "/",
  enableHover = true,
}: Props): JSX.Element => {
  const [isHovered, setIsHovered] = useState(false);
  const location = useLocation();
  const isHomePage = location.pathname === "/";

  const handleClick = (e: React.MouseEvent) => {
    if (isHomePage) {
      e.preventDefault();
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  // Check if this is the mobile menu logo (which is scaled up)
  const isMobileMenuLogo = className.includes('scale-[1.39]');

  const DefaultLogo = () => (
    <svg
      className="w-[42px] h-[42px]"
      fill="none"
      viewBox="0 0 40 40"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        height="38.75"
        rx="19.375"
        stroke="var(--fy-grey)"
        strokeWidth={isMobileMenuLogo ? "0.75" : (window.innerWidth < 768 ? "1.0" : "1.25")}
        width="38.75"
        x="0.625"
        y="0.625977"
      />
      <path
        d="M28.9944 18.6333C28.9944 18.3816 28.6775 18.198 28.4496 18.3344C27.2432 19.0634 25.9533 19.7714 24.8359 20.6315C24.8136 19.8343 24.8136 19.0371 24.8247 18.2347C24.8247 18.1823 24.8136 18.1403 24.797 18.1036C25.6142 17.3431 25.9589 15.8432 26.0201 14.8519C26.1646 12.5233 24.4967 10.7821 21.9782 11.0233C20.6662 11.1492 19.3096 12.0355 18.6981 13.1946C18.3256 12.0565 17.4194 11.1649 15.8238 11.0495C13.6111 10.8922 11.2649 12.602 11.0203 14.7103C10.8479 16.2155 11.7931 17.4795 13.1051 18.1036C13.0662 18.1088 13.0217 18.1141 12.9828 18.1193C12.9328 18.1298 12.8994 18.1508 12.8828 18.1875C12.7827 18.198 12.6771 18.2662 12.6715 18.3763C12.5659 20.5424 12.6548 22.7189 12.5714 24.8849C12.5659 25.079 12.7382 25.1996 12.9217 25.2153C14.5395 25.3779 16.1852 25.4356 17.8363 25.4461C16.8801 26.3587 16.0239 27.3499 15.1622 28.3412C15.0176 28.5037 15.2456 28.7293 15.4124 28.5772C16.3575 27.7433 17.3026 26.9094 18.1699 26.0073C18.1866 26.3797 18.2311 26.752 18.2422 27.1192C18.2589 27.717 18.1477 28.3412 18.4312 28.8866C18.5202 29.0544 18.7704 29.023 18.8649 28.8866C19.2318 28.3464 19.1373 27.6017 19.0984 26.9828C19.0761 26.6681 19.0595 26.3325 19.0039 26.0073C19.3819 26.4583 19.8434 26.8569 20.277 27.245C20.8496 27.759 21.4556 28.4461 22.1673 28.7765C22.4452 28.9023 22.8177 28.6296 22.6232 28.3464C22.1784 27.7118 21.4278 27.2345 20.833 26.7206C20.3326 26.2905 19.8267 25.808 19.2596 25.4461C21.1165 25.4251 22.9678 25.357 24.797 25.2888C24.9804 25.2835 25.1972 25.1314 25.1694 24.9374C25.0638 24.1769 24.9915 23.4164 24.9359 22.6612C26.0701 23.2696 27.2487 23.794 28.344 24.4706C28.5719 24.6122 28.9666 24.4286 28.9277 24.1507C28.6887 22.3151 28.9666 20.4794 29 18.6386L28.9944 18.6333ZM19.7878 18.1665C19.2818 18.1613 18.7759 18.1456 18.27 18.1298C17.992 18.1193 17.7085 18.1036 17.4249 18.0879C17.9197 17.6578 18.3089 17.0494 18.5591 16.3676C18.7481 17.0914 19.1595 17.726 19.7878 18.1665ZM11.6819 15.1194C11.6318 13.4044 13.2108 12.0565 14.8953 11.7523C19.015 11.0128 19.204 17.6788 15.657 17.9935C15.4735 17.9882 15.2956 17.983 15.1122 17.983C13.4776 17.6263 11.7375 17.018 11.6819 15.1194ZM13.283 24.5755C13.3442 22.5353 13.3776 20.4794 13.094 18.455C14.7452 18.8693 16.5799 18.8116 18.2756 18.8955C20.2214 18.9899 22.1673 19.0476 24.1076 18.8379C24.0464 20.7521 24.1687 22.6717 24.3855 24.5755C20.694 24.565 16.9691 24.864 13.283 24.5755ZM21.8893 18.1088C19.8545 18.0197 19.1706 16.7347 18.9427 15.1456C19.1818 13.4149 19.8656 11.8887 22.0227 11.7051C24.2521 11.5163 25.4141 13.0897 25.2139 15.0302C25.0193 16.9288 24.0186 18.198 21.8837 18.1036L21.8893 18.1088ZM28.0827 23.4899C27.0764 22.9549 26.0757 22.3937 25.0138 21.9689C24.9693 21.9532 24.9304 21.9427 24.8859 21.9427C24.8692 21.6647 24.8581 21.3815 24.847 21.1035C26.0312 20.621 27.1487 19.9445 28.2383 19.2836C28.1605 20.6892 27.9882 22.0895 28.0771 23.4951L28.0827 23.4899Z"
        fill="var(--fy-grey)"
      />
    </svg>
  );

  const FillLogo = () => (
    <svg
      className="w-[42px] h-[42px]"
      fill="none"
      viewBox="0 0 40 40"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        fill="var(--fy-grey)"
        height="39"
        rx="19.5"
        width="39"
        x="0.5"
        y="0.500977"
      />
      <rect
        height="39"
        rx="19.5"
        stroke="var(--fy-grey)"
        strokeWidth={isMobileMenuLogo ? "0.75" : (window.innerWidth < 768 ? "1.0" : "1.25")}
        width="39"
        x="0.5"
        y="0.500977"
      />
      <path
        d="M28.9944 18.6333C28.9944 18.3816 28.6775 18.198 28.4496 18.3344C27.2432 19.0634 25.9533 19.7714 24.8359 20.6315C24.8136 19.8343 24.8136 19.0371 24.8247 18.2347C24.8247 18.1823 24.8136 18.1403 24.797 18.1036C25.6142 17.3431 25.9589 15.8432 26.0201 14.8519C26.1646 12.5233 24.4967 10.7821 21.9782 11.0233C20.6662 11.1492 19.3096 12.0355 18.6981 13.1946C18.3256 12.0565 17.4194 11.1649 15.8238 11.0495C13.6111 10.8922 11.2649 12.602 11.0203 14.7103C10.8479 16.2155 11.7931 17.4795 13.1051 18.1036C13.0662 18.1088 13.0217 18.1141 12.9828 18.1193C12.9328 18.1298 12.8994 18.1508 12.8828 18.1875C12.7827 18.198 12.6771 18.2662 12.6715 18.3763C12.5659 20.5424 12.6548 22.7189 12.5714 24.8849C12.5659 25.079 12.7382 25.1996 12.9217 25.2153C14.5395 25.3779 16.1852 25.4356 17.8363 25.4461C16.8801 26.3587 16.0239 27.3499 15.1622 28.3412C15.0176 28.5037 15.2456 28.7293 15.4124 28.5772C16.3575 27.7433 17.3026 26.9094 18.1699 26.0073C18.1866 26.3797 18.2311 26.752 18.2422 27.1192C18.2589 27.717 18.1477 28.3412 18.4312 28.8866C18.5202 29.0544 18.7704 29.023 18.8649 28.8866C19.2318 28.3464 19.1373 27.6017 19.0984 26.9828C19.0761 26.6681 19.0595 26.3325 19.0039 26.0073C19.3819 26.4583 19.8434 26.8569 20.277 27.245C20.8496 27.759 21.4556 28.4461 22.1673 28.7765C22.4452 28.9023 22.8177 28.6296 22.6232 28.3464C22.1784 27.7118 21.4278 27.2345 20.833 26.7206C20.3326 26.2905 19.8267 25.808 19.2596 25.4461C21.1165 25.4251 22.9678 25.357 24.797 25.2888C24.9804 25.2835 25.1972 25.1314 25.1694 24.9374C25.0638 24.1769 24.9915 23.4164 24.9359 22.6612C26.0701 23.2696 27.2487 23.794 28.344 24.4706C28.5719 24.6122 28.9666 24.4286 28.9277 24.1507C28.6887 22.3151 28.9666 20.4794 29 18.6386L28.9944 18.6333ZM19.7878 18.1665C19.2818 18.1613 18.7759 18.1456 18.27 18.1298C17.992 18.1193 17.7085 18.1036 17.4249 18.0879C17.9197 17.6578 18.3089 17.0494 18.5591 16.3676C18.7481 17.0914 19.1595 17.726 19.7878 18.1665ZM11.6819 15.1194C11.6318 13.4044 13.2108 12.0565 14.8953 11.7523C19.015 11.0128 19.204 17.6788 15.657 17.9935C15.4735 17.9882 15.2956 17.983 15.1122 17.983C13.4776 17.6263 11.7375 17.018 11.6819 15.1194ZM13.283 24.5755C13.3442 22.5353 13.3776 20.4794 13.094 18.455C14.7452 18.8693 16.5799 18.8116 18.2756 18.8955C20.2214 18.9899 22.1673 19.0476 24.1076 18.8379C24.0464 20.7521 24.1687 22.6717 24.3855 24.5755C20.694 24.565 16.9691 24.864 13.283 24.5755ZM21.8893 18.1088C19.8545 18.0197 19.1706 16.7347 18.9427 15.1456C19.1818 13.4149 19.8656 11.8887 22.0227 11.7051C24.2521 11.5163 25.4141 13.0897 25.2139 15.0302C25.0193 16.9288 24.0186 18.198 21.8837 18.1036L21.8893 18.1088ZM28.0827 23.4899C27.0764 22.9549 26.0757 22.3937 25.0138 21.9689C24.9693 21.9532 24.9304 21.9427 24.8859 21.9427C24.8692 21.6647 24.8581 21.3815 24.847 21.1035C26.0312 20.621 27.1487 19.9445 28.2383 19.2836C28.1605 20.6892 27.9882 22.0895 28.0771 23.4951L28.0827 23.4899Z"
        fill="var(--fy-blue)"
      />
    </svg>
  );

  return (
    <a
      href={url}
      className={`relative block ${className}`}
      onMouseEnter={() => enableHover && window.innerWidth >= 768 && setIsHovered(true)}
      onMouseLeave={() => enableHover && window.innerWidth >= 768 && setIsHovered(false)}
      onClick={handleClick}
    >
      <div style={{ width: 42, height: 42, position: 'relative' }}>
        <div
          className="absolute inset-0 transition-opacity duration-200"
          style={{
            opacity: enableHover && isHovered && window.innerWidth >= 768 ? 0 : 1
          }}
        >
          <DefaultLogo />
        </div>
        <div
          className="absolute inset-0 transition-opacity duration-200"
          style={{
            opacity: enableHover && isHovered && window.innerWidth >= 768 ? 1 : 0
          }}
        >
          <FillLogo />
        </div>
      </div>
    </a>
  );
}; 